import {Pipe, PipeTransform} from "@angular/core";
import {User} from "../../shared/api/users/api.models";

@Pipe({
    name: 'users'
})

export class UsersPipe implements PipeTransform {
    transform(value: User[], username: string, company: any, role: any) {
        role    = role    === 'null' ? null : role;
        company = company === 'null' ? null : company;

        return value.filter((value: User) => {
            if (value.isHidden === true) {
                return false;
            }

            if (username && value.username.toLowerCase().indexOf(username.toLowerCase()) === -1) {
                return false;
            }

            if (company && value.companyId !== Number.parseInt(company)) {
                return false;
            }

            if (role && value.roleId !== Number.parseInt(role)) {
                return false;
            }

            return true;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/users/users.pipe.ts